import { TextField } from '@mui/material';
import React from 'react';

// Small pieces the two-step sign-in steps (MfaCodeStep, MfaEnrollStep) and the Sign-in security page share.

export const METHOD_LABELS = {
    totp: 'Authenticator app',
    sms: 'Text message',
    recovery_code: 'Recovery code',
};

// Seconds left before "Resend" may be used: `start(n)` from the answer's `resend_after` (or a 429's
// `retry_after`), ticking down once a second to 0.
export function useCountdown() {
    const [left, setLeft] = React.useState(0);
    const running = left > 0;
    React.useEffect(() => {
        if (!running) {
            return undefined;
        }
        const id = setInterval(() => setLeft((s) => (s <= 1 ? 0 : s - 1)), 1000);
        return () => clearInterval(id);
    }, [running]);
    const start = React.useCallback((seconds) => setLeft(Number.isInteger(seconds) && seconds > 0 ? seconds : 0), []);
    return [left, start];
}

// The code input. A 6-digit code (authenticator app, text message) gets the one-time-code hints that let
// phones offer the texted code and open the number pad; a recovery code is free text (the backend ignores
// case, spaces and dashes).
export function CodeField({ recovery = false, value, onChange, label, ...rest }) {
    return (
        <TextField
            fullWidth
            variant="outlined"
            margin="normal"
            label={label || (recovery ? 'Recovery code' : '6-digit code')}
            value={value}
            onChange={(ev) => onChange(recovery ? ev.target.value : ev.target.value.replace(/\D/g, '').slice(0, 6))}
            autoComplete={recovery ? 'off' : 'one-time-code'}
            inputProps={recovery
                ? { autoCapitalize: 'characters', spellCheck: false }
                : { inputMode: 'numeric', pattern: '[0-9]*', maxLength: 6 }}
            {...rest}
        />
    );
}

// A code worth sending: six digits, or any recovery code.
export const codeReady = (code, recovery = false) => (recovery ? code.trim().length > 0 : /^\d{6}$/.test(code));
